import { useworkspaceAuthMeV2Query, WorkspaceStatusEnum } from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';

export const useWorkspaceStatus = () => {
  const workspaceAuthMeV2 = useworkspaceAuthMeV2Query(cacheOnly);
  const status = workspaceAuthMeV2?.data?.workspaceAuthMeV2?.data?.status;

  const isSignUpCompleted = [WorkspaceStatusEnum.approved, WorkspaceStatusEnum.created].includes(
    status as WorkspaceStatusEnum
  );

  return {
    status,
    isSignUpCompleted,
  };
};
